import React from 'react'
import { isEmpty } from 'lodash'

import { DragAndDropFileUploader } from '@/components/forms/formik/file-uploader/DragAndDropFileUploader'
import { ErrorMessage } from '@/components/forms/ErrorMessage'

export const ContactListUploadPage = ({ values, setFieldValue, formikProps, uploadError }) => {
  return (
    <>
      <div className="mb">
        <p>Upload a CSV file with contacts for this list.</p>
        <p className="secondary-text">
          Required column: <strong>phone_number</strong>. Optional columns: first_name, last_name,
          timezone. Any additional columns will be saved as custom data and passed to the AI agent
          during the call.
        </p>
      </div>
      <DragAndDropFileUploader
        name="file"
        label="Contacts CSV"
        acceptedFileTypes={{ 'text/csv': ['.csv'] }}
        acceptedFileMessage="CSV files only. Max file size: 10MB"
        maxSize={10485760}
        maxFiles={1}
        multiple={false}
        useIconLayout={false}
        values={values}
        setFieldValue={setFieldValue}
        {...formikProps}
      />
      {!isEmpty(uploadError) && (
        <div className="mt" data-testid="upload-error">
          {uploadError.map((message) => (
            <ErrorMessage key={message} content={message} />
          ))}
        </div>
      )}
    </>
  )
}
